(() => {
  function init(root = document) {
    root.querySelectorAll('[data-loncry-announcement-drag]').forEach(bar => {
      if (bar.dataset.flipReady) return;
      bar.dataset.flipReady = 'true';
      const items = [...bar.querySelector('.loncry-announcement__track').children];
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      let index = 0, busy = false, hover = false, pointer = null;
      let nextAt = performance.now() + 4500;
      items.forEach((item, i) => {
        item.classList.toggle('is-current', i === 0);
        item.setAttribute('aria-hidden', String(i !== 0));
      });
      const show = direction => {
        if (busy || items.length < 2) return;
        busy = true;
        const old = items[index];
        index = (index + direction + items.length) % items.length;
        const current = items[index];
        old.classList.remove('is-current');
        old.classList.add('is-outgoing');
        old.setAttribute('aria-hidden', 'true');
        current.classList.add('is-current', 'is-incoming');
        current.setAttribute('aria-hidden', 'false');
        setTimeout(() => {
          old.classList.remove('is-outgoing');
          current.classList.remove('is-incoming');
          busy = false;
        }, reduced.matches ? 0 : 480);
        nextAt = performance.now() + 4500;
      };
      bar.addEventListener('mouseenter', () => { hover = true; });
      bar.addEventListener('mouseleave', () => { hover = false; nextAt = performance.now() + 4500; });
      bar.addEventListener('pointerdown', e => {
        if (e.button !== 0) return;
        pointer = { id: e.pointerId, x: e.clientX };
        bar.setPointerCapture(e.pointerId);
        bar.classList.add('is-dragging');
      });
      const end = e => {
        if (!pointer || pointer.id !== e.pointerId) return;
        const delta = e.clientX - pointer.x;
        pointer = null;
        bar.classList.remove('is-dragging');
        if (e.type === 'pointerup' && Math.abs(delta) > 30) show(delta < 0 ? 1 : -1);
        nextAt = performance.now() + 4500;
      };
      bar.addEventListener('pointerup', end);
      bar.addEventListener('pointercancel', end);
      bar.addEventListener('lostpointercapture', end);
      bar.addEventListener('keydown', e => {
        if (e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
        e.preventDefault();
        show(e.key === 'ArrowRight' ? 1 : -1);
      });
      const timer = setInterval(() => {
        if (!bar.isConnected) { clearInterval(timer); return; }
        if (!reduced.matches && !document.hidden && !hover && !pointer && !bar.matches(':focus-visible') && performance.now() >= nextAt) show(1);
      }, 250);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();
  document.addEventListener('shopify:section:load', e => init(e.target));
})();
